import { overviewToolTips, tabModes } from '../../constants/agentProductionConstants';
import { agentProductionTerms, searchTerms } from '../../../constants';
import {
    getAdditionalColumnCount,
    transformSchemaTableColumns
} from '../../helpers/schemaTableHelpers';

export const getAdditionalTableHeaders = (columns, agentDataLength, dateRangesText, col1TitlePrefix, tooltips = overviewToolTips) => {
    const overviewColumns = transformSchemaTableColumns(tooltips, tabModes.OVERVIEW);

    const additionalAddressColumns = getAdditionalColumnCount(
        columns, overviewColumns?.officeAddress.id
    );
    const areaColCounter = columns.filter(
        (overviewColumn) =>
            overviewColumn.headerPlacement === 'area' && overviewColumn.isDisplayed
    ).length + additionalAddressColumns;

    const mlsColCounter = columns.filter(
        (overviewColumn) =>
            overviewColumn.headerPlacement === 'mls' && overviewColumn.isDisplayed
    ).length;


    return [
        {
            column1: {
                title: `${col1TitlePrefix || agentProductionTerms.currentSearch} (${dateRangesText.currentSearch.lastIntervalText}: ${dateRangesText.currentSearch.from} - ${dateRangesText.currentSearch.to}) - ${agentDataLength} ${searchTerms.agents }`,
                attrs: {
                    colSpan: 2 + areaColCounter,
                    className: `border border-end-5 text-center ${areaColCounter === 0 ? 'd-none' : ''}`
                }
            },
            column2: {
                title: `${agentProductionTerms.allMlsTransactions} ${dateRangesText.allMls.lastIntervalText} (${dateRangesText.allMls.from} - ${dateRangesText.allMls.to})`,
                attrs: {
                    colSpan: areaColCounter === 0 ? 2 + mlsColCounter : mlsColCounter,
                    className: `border text-center ${mlsColCounter === 0 ? 'd-none' : ''}`
                }
            }
        }
    ];
};
